import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DockerOutlinedSvg from "@ant-design/icons-svg/es/asn/DockerOutlined";
import AntdIcon from "../components/AntdIcon";
var DockerOutlined = function DockerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DockerOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DockerOutlined.displayName = 'DockerOutlined';
}
export default /*#__PURE__*/React.forwardRef(DockerOutlined);